function Home() {
  return <div style={{ paddingTop: ' 25px' }}>Home</div>;
}

export default Home;
